import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/*
 * shadcn/ui Sonner without next-themes: the colors come from the Hangar tokens through sonner's CSS variables (and
 * a few rules in styles/theme.css), so the toasts follow the theme without a theme prop. Bottom-right as the design
 * says; on phones they sit above the tab bar.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      position="bottom-right"
      closeButton
      duration={5000}
      gap={8}
      mobileOffset={{ bottom: 'calc(80px + env(safe-area-inset-bottom))', left: 16, right: 16 }}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
          '--width': 'min(380px, calc(100vw - 32px))',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
